module.exports = __webpack_public_path__ + "img/incomplete_left.e191bb47.jpg";